<template>
  <introduce-page>
    <div style="width: 100%;display: flex;flex-wrap: wrap;">
      <div v-for="(honor, i) in honorList" :key="i" style="width: 30%;margin-right: 3%;">
        <div style="width: 100%;height: 200px;border: 1px solid #000;display: flex;align-items: center;justify-content: center;">
          <el-image fit="cover" :src="getImageUrl(honor.id)" style="width: 96%;height: 180px;"></el-image>
        </div>
        <el-row style="text-align: center;margin-top: 10px;margin-bottom: 20px;">{{honor.honorName}}</el-row>
      </div>
    </div>
    <el-row style="height: 40px;width: 100%;text-align: center;margin-top: 20px;">
      <el-pagination background layout="total, prev, pager, next" :page-size="15" @current-change="pageChange"
                     :current-page="pageInfo.pageNum" :page-count="pageInfo.pages" :total="pageInfo.total" />
    </el-row>
  </introduce-page>
</template>

<script>
import IntroducePage from './IntroducePage'
export default {
  name: 'HonorPage',
  components: { IntroducePage },
  data() {
    return {
      honorList: [],
      pageInfo: {
        total: 0,
        pageNum: 1,
        pages: 0
      }
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.doQuery(1)
  },
  methods: {
    doQuery(page) {
      let param = {page: page, rows: 15}
      this.$api.honorManage.getHonorInfo(param).then(res => {
        this.honorList = res.data.rows
        this.pageInfo.total = res.data.total
        this.pageInfo.pageNum = res.data.pageNum
        this.pageInfo.pages = res.data.pages
      })
    },
    pageChange(page) {
      this.doQuery(page)
    },
    getImageUrl(id) {
      return '/myApi/honorInfo/getImageById?id=' + id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/introduce/HonorPage.vue